import type { FC } from "react";

import { Table } from "@similarweb/pro-logic-components";

import { translate } from "app/filters/i18nFilter";

import { WithBorderBottom } from "../styledComponents";
interface ISettingsLocale {
    addToDashboardTooltip: string;
}

interface IExcelExportConfig {
    excelDownloadUrl: string;
    onExcelDownloaded: () => void;
}

interface ISegmentCreation {
    onNewListButtonClick: () => void;
    isCreatingSegment: boolean;
}

interface ITableControlsProps {
    search: string;
    onSearchChange: (search: string) => void;
    settingsLocale: ISettingsLocale;
    excelExportConfig: IExcelExportConfig;
    handleOpenDashboard: () => void;
    segmentCreation: ISegmentCreation;
    selectedRowKeys: string[];
}

export const TableControls: FC<ITableControlsProps> = ({
    search,
    onSearchChange,
    settingsLocale,
    excelExportConfig,
    handleOpenDashboard,
    segmentCreation,
    selectedRowKeys,
}) => {
    const textKey = translate(
        selectedRowKeys.length === 1
            ? `${selectedRowKeys.length} ${translate("folders.analysis.table.segment.selected")}`
            : `${selectedRowKeys.length} ${translate("folders.analysis.table.segments.selected")}`,
    );

    return (
        <>
            <WithBorderBottom>
                <Table.TableTop.Filters
                    filters={[
                        {
                            filter: "search",
                            placeholder: translate("forms.search.placeholder"),
                            onSearchChange,
                            initialValue: search,
                        },
                    ]}
                />
                <Table.TableTop.Settings
                    locale={settingsLocale}
                    showAddToDashboard
                    onAddToDashboard={handleOpenDashboard}
                    excelExportConfig={excelExportConfig}
                />
            </WithBorderBottom>
            <WithBorderBottom>
                <Table.TableTop.Selection
                    selectText={textKey}
                    hideCount={true}
                    actionButtons={[
                        {
                            iconName: "add",
                            children: translate("table.selection.create.new.segment"),
                            onClick: segmentCreation.onNewListButtonClick,
                            alwaysAvailable: true,
                            isDisabled: segmentCreation.isCreatingSegment || selectedRowKeys.length === 0,
                        },
                    ]}
                />
            </WithBorderBottom>
        </>
    );

    return null;
};
